// import './modules'

$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 300) {
    $('.header').addClass('header--scrolled');
  } else {
    $('.header').removeClass('header--scrolled');
  }
});

// $('.hero__benefits-pagination').on('click', function () {
//   var item = $('.hero__benefits-item');
//   item.removeClass('is-active');
//   $(this).parent(item).addClass('is-active');
//   $('.hero__benefits').addClass('is-animated').delay(800).queue(function () {
//     $(this).removeClass("is-animated").dequeue();
//   });
// });

// if ($(window).width() < 1025) {
//   $('.hero__benefits').slick({
//     arrows: false,
//     dots: true,
//   });
// }

$('.cases-inner__list').slick({
  fade: true,
  prevArrow: $('.cases-inner__pagination-prev'),
  nextArrow: $('.cases-inner__pagination-next'),
  adaptiveHeight: true,
});

$('.game__list').slick({
  arrows: false,
  fade: true,
  dots: true,
  speed: 500,
  initialSlide: 1,
});

$('.cases_page__carousel').each(function() {
  $(this).slick({
    dots: true,
    arrows: false,
    fade: true,
  })
})

$('.slick-dots').addClass('cases_page__carousel-position cases_page__carousel-dots');


$('.article__gallery-list').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: $('.carousel-arrow--prev'),
  nextArrow: $('.carousel-arrow--next'),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

if ($(window).width() < 767) {
  $('.carousel_mobile_has_dots').slick({
    dots: true,
    arrows: false,
  });
  $('.carousel_mobile_has_arrows').slick({
    prevArrow: $('.carousel-arrow--prev'),
    nextArrow: $('.carousel-arrow--next'),
  });

  $('.team__list').slick({
    centerMode: true,
    centerPadding: '80px',
    prevArrow: $('.team__arrow--prev'),
    nextArrow: $('.team__arrow--next'),
  });

  $('.js_tabs_mob').on('click', function () {
    $(this).parent().toggleClass('tabs--open');
  });
}
var masonryContainer = $('.blog__grid');

var massonryInit = function () {
  masonryContainer.masonry({
    itemSelector: '.blog__grid-item',
  });
};

window.onload = function () {
  massonryInit();
};
massonryInit();

$('.modal-link').fancybox({
  smallBtn: false,
  closeExisting: true,
  buttons: [],
  closeBtn: 'modal__close',
});

$('.tabs-container').tabslet();

$('.tabs-container').on('_after', function () {
  massonryInit();
});

$('.price__tabs-item').on('click', function() {
  $(this).parent().toggleClass('tabs--open')
})

// work link more

$('.work__item-more').on('click', function (e) {
  e.preventDefault();
  var link = $(this);
  $(this)
    .siblings('.work__item-text')
    .slideToggle('slow', function () {
      if ($(this).is(':visible')) {
        link.text('Скрыть');
      } else {
        link.text('Подробнее');
      }
    });
});

// get value

$('#get_value').keyup(function () {
  var value = $(this).val();
  $('#give_value').val(value);
});

// animation
// import Wow from 'wow.js';
// const wow = new Wow();

// jQuery(document).ready(function () {
//   wow.init();
// });

// Yandex map

// quiz

function calc() {
  var length = $('.js-tab-trigger').length;

  function calcInner() {
    function progress(id) {
      var percent = (parseInt(id) / length) * 100;
      $('.calc__progress-inner').css({ width: percent + '%' });
      $('.calc__progress-steps').text('Шаг ' + id + ' из ' + length);
    }

    $('.js-tab-trigger').click(function (e) {
      e.preventDefault();
      var navId = $(this).attr('data-tab'),
        content = $('.js-tab-content[data-tab="' + navId + '"]');

      if (content.find('.calc__card--checked').length > 0) {
        $('.js-tab-trigger.active').removeClass('active');
        $(this).addClass('active');
        $('.js-tab-content.active').removeClass('active');
        content.addClass('active');

        progress(navId);
      }
    });

    $('.calc__next').on('click', function (e) {
      e.preventDefault();
      var content = $(this).parents('.js-tab-content'),
        contentId = content.attr('data-tab');

      if (content.find('.calc__card--checked').length > 0) {
        content.removeClass('active');
        content.next().addClass('active');

        $('.js-tab-trigger.active')
          .removeClass('active')
          .next()
          .addClass('active');

        progress(++contentId);
      }
    });
  }

  calcInner();

  $('.calc__card input[type="radio"]').click(function () {
    $(this)
      .parents('.calc__cards')
      .find('.calc__card')
      .removeClass('calc__card--checked');
    if (this.checked) {
      $(this).parent().addClass('calc__card--checked');
    }
  });
}

calc();

// players bg animation

function gameBgAnimation() {
  // var windowWidth = $(window).width();

  $('.game__item').mousemove(function (event) {
    var moveX = ($(window).width() / 2 - event.pageX) * 0.01;
    var moveY = ($(window).height() / 2 - event.pageY) * 0.01;
    $('.game__item-bg').css(
      'transform',
      'translate(' + moveX + 'px,' + moveY + 'px)'
    );
  });
}

gameBgAnimation();

var body = $('body');
body.on('click', '.page-reviews__link-more', function (e) {
  e.preventDefault();
  var button = $(this),
    buttonText = button.html(),
    queryArgs = button.data('args'),
    maxPage = button.data('max-page'),
    currentPage = button.data('current-page');

  $.ajax({
    url: ajax.ajaxurl, // AJAX handler
    data: {
      action: 'get_reviews', // the parameter for admin-ajax.php
      query: queryArgs,
      page: currentPage,
    },
    type: 'POST',
    beforeSend: function (xhr) {
      button.text('Загрузка...'); // some type of preloader
    },
    success: function (data) {
      currentPage++;
      button
        .html(buttonText)
        .data('current-page', currentPage)
        .parent()
        .before(data);

      if (currentPage == maxPage) {
        button.remove();
      }
    },
  });
  return false;
});

body.on('click', '.js-blog-load-more', function (e) {
  e.preventDefault();
  var button = $(this),
    buttonText = button.html(),
    queryArgs = button.data('args'),
    maxPage = button.data('max-page'),
    currentPage = button.data('current-page');

  $.ajax({
    url: ajax.ajaxurl, // AJAX handler
    data: {
      action: 'get_blog_posts',
      query: queryArgs,
      page: currentPage,
    },
    type: 'POST',
    beforeSend: function (xhr) {
      button
        .fadeOut(200)
        .html(buttonText.replace('Больше статей', 'Загрузка...'))
        .fadeIn(300);
    },
    success: function (data) {
      currentPage++;
      button.html(buttonText).data('current-page', currentPage);
      const items = $(data);
      button
        .parent()
        .find('.blog__grid')
        .append(items)
        .masonry('appended', items);

      setTimeout(() => {
        masonryContainer.masonry();
      }, 1);

      if (currentPage == maxPage) {
        button.remove();
      }
    },
  });
  return false;
});

body.on('click', '.js-loadmore-cases', function (e) {
  e.preventDefault();
  var button = $(this),
    buttonText = button.html(),
    queryArgs = button.data('args'),
    maxPage = button.data('max-page'),
    currentPage = button.data('current-page');

  $.ajax({
    url: ajax.ajaxurl, // AJAX handler
    data: {
      action: 'get_cases_posts',
      query: queryArgs,
      page: currentPage,
    },
    type: 'POST',
    beforeSend: function (xhr) {
      button
        .fadeOut(200)
        .html(buttonText.replace('Больше статей', 'Загрузка...'))
        .fadeIn(300);
    },
    success: function (data) {
      currentPage++;
      button
        .html(buttonText)
        .data('current-page', currentPage)
        .parent()
        .find('.cases-list')
        .append(data);
      if (currentPage == maxPage) {
        button.remove();
      }
    },
  });
  return false;
});

//mail
$('.form').on('submit', function (e) {
  e.preventDefault();
  var form = $(this);
  var currentUrlData = '&url=' + window.location.href.replace('?', '&');
  $.ajax({
    url: ajax.ajaxurl,
    data: form.serialize() + currentUrlData,
    type: form.attr('method'),
    beforeSend: function (xhr) {
      // filter.find('button').text('Обработка...'); // changing the button label
    },
    success: function (data) {
      if (data.success) {
        form[0].reset();
        $.fancybox.open($('#done_modal'), {
          smallBtn: false,
          closeExisting: true,
          buttons: [],
        });
        ym(56209222,'reachGoal','form_sent')
        ym(68569150,'reachGoal','form_sent')
      } else {
        $.fancybox.open($('#fail_modal'), {
          smallBtn: false,
          closeExisting: true,
          buttons: [],
        });
      }
    },
  });
});

function chartInit() {
  var canvasContainer = document.querySelectorAll('.case-canvas');
  Array.from(canvasContainer).map((canvas) => {
    var ctx = canvas.getContext('2d');
    var labels = canvas.dataset.labels;
    var data = canvas.dataset.data;
    data = data.split(',');
    labels = labels.split(',');
    data.pop();
    labels.pop();
    var max = Math.max(...data);
    var step = max / data.length;
    if (!ctx) {
      return;
    }
    var chartData = {
      labels: labels,
      datasets: [
        {
          label: 'Посетители',
          data: data,
          backgroundColor: 'rgba(249, 221, 227, 0.7)',
          borderColor: '#f9825a',
          pointBackgroundColor: '#f9825a',
          pointRadius: 4,
        },
      ],
    };

    var chartOptions = {
      legend: {
        display: false,
        fontColor: '#525899',
        defaultFontFamily: '"Circe", "Helvetica Neue", "Arial"',
      },
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 3,
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              max: max,
              stepSize: step,
            },
          },
        ],
      },
      layout: {
        padding: {
          left: -5,
        },
      },
    };
    Chart.defaults.global.defaultFontColor = '#525899';
    Chart.defaults.global.defaultFontFamily =
      '"Circe", "Helvetica Neue", "Arial"';
    // Chart.defaults.gridLines.drawTicks = 'false';
    var lineChart = new Chart(ctx, {
      type: 'line',
      data: chartData,
      options: chartOptions,
    });
  });
}

chartInit();

const getForm = $('.js-form');
const formSiteName = $('.js-formSiteName');
getForm.on('submit', function (e) {
  e.preventDefault();
  let siteName = $('.js-siteName').val();
  formSiteName.val(siteName);
  $.fancybox.open({
    src: '#application_modal',
    smallBtn: false,
    closeExisting: true,
    buttons: [],
  });
});

//fancybox to blogs and cases
$('.cases_page .wp-block-image a').fancybox({
  loop: true,
  buttons: ['thumbs', 'close'],
});
$('.article .wp-block-image a').fancybox({
  loop: true,
  buttons: ['thumbs', 'close'],
});
$('[data-fancybox="case-gallery"]').fancybox({
  loop: true,
  buttons: ['thumbs', 'close'],
});
//new header hamburger
function headerLayouter() {
  var hamburger = $('.header__hamburger'),
    header = $('.header'),
    htmlBody = $('body, html'),
    overlay = $('.page_overlay');
  hamburger.click(function () {
    $(this).toggleClass('header__hamburger_active');
    header.toggleClass('header_opened');
    overlay.toggleClass('is-active');
    htmlBody.toggleClass('overflow-h');
  });
}
headerLayouter();
// show nav submenu on arrow click
function submenuShow() {
  $('.navigation__item__more').click(function () {
    var siblingSubmenu = $(this).siblings('.navigation__submenu-wrap');
    if (siblingSubmenu.hasClass('navigation__submenu-wrap_visible')) {
      siblingSubmenu.removeClass('navigation__submenu-wrap_visible');
      $(this).removeClass('navigation__item__more_active');
    } else {
      $(
        '.navigation__submenu--1 .navigation__submenu-wrap_visible'
      ).removeClass('navigation__submenu-wrap_visible');
      siblingSubmenu.addClass('navigation__submenu-wrap_visible');
      $('.navigation__submenu--1 .navigation__item__more_active').removeClass(
        'navigation__item__more_active'
      );
      $(this).addClass('navigation__item__more_active');
    }
  });
}
submenuShow();

//show callback menu on mobile
function callbackMobile() {
  $('.header__contacts__button').click(function () {
    $('.header__row_3').toggleClass('header__row_3_active');
    $('.header__contacts__button').toggleClass(
      'header__contacts__button_active'
    );
    //check if hambureger is clicked
    if ($('.header_opened')) {
      //move second row
      $('.header__nav').toggleClass('header__nav_moved');
    }
  });
}
callbackMobile();
//Smooth scroll for links
$('.cases_page a[href*=\\#]').on('click', function (event) {
  event.preventDefault();
  $('.toc_small').removeClass('toc_small_active');
  $('.cases_page__article').removeClass('cases_page__article_purple');
  $('html,body').animate({ scrollTop: $(this.hash).offset().top - 100 }, 500);
});
$('.article a[href*=\\#]').on('click', function (event) {
  event.preventDefault();
  $('.toc_small').removeClass('toc_small_active');
  $('.article__content').removeClass('article__content_purple');
  $('html,body').animate({ scrollTop: $(this.hash).offset().top - 100 }, 500);
});
//Toc small toggler
function tocToggler() {
  $('.toc_small').click(function (e) {
    if (
      e.target.className != 'toc__close' &&
      e.target.className != 'toc__list__link'
    ) {
      $('.toc_small').addClass('toc_small_active');
      $('.cases_page__article').addClass('cases_page__article_purple');
      $('.article__content').addClass('article__content_purple');
    }
  });
  $('.toc__close').click(function () {
    $('.toc_small').removeClass('toc_small_active');
    $('.cases_page__article').removeClass('cases_page__article_purple');
    $('.article__content').removeClass('article__content_purple');
  });
}
tocToggler();
//update cookie with geo
$('.geochanger').on('click', function(event){
  event.preventDefault();
  const href = $(this).attr('data-href');
  const newCity = 'city=' + $(this).attr('data-city');
  document.cookie = newCity;
  if(href) {
    return window.location.href = href;
  }
  location.reload();
})


// WEBPACK FOOTER //
// ./scripts/myscripts.js